import type { PostHog } from 'posthog-js';
import { sendAnalyticsBeacon } from 'utils/analyticsBeacon';
import { getAnalyticsDistinctId, isPostHogReady } from 'utils/analyticsDistinctId';
import { createRandomId } from 'utils/createRandomId';
import { isAnalyticsConfigured } from 'utils/posthogClient';

type CaptureAnalyticsEventOptions = {
    insertId?: string;
};

/**
 * Captures analytics events via PostHog when initialized, otherwise via the /collect beacon.
 */
export const captureAnalyticsEvent = (
    posthog: PostHog | null | undefined,
    eventName: string,
    properties?: Record<string, unknown>,
    options?: CaptureAnalyticsEventOptions
): string => {
    const insertId = options?.insertId ?? createRandomId();

    if (!isAnalyticsConfigured()) {
        return insertId;
    }

    const distinctId = getAnalyticsDistinctId(posthog);
    const now = new Date();
    const timestamp = Date.now();

    const eventProperties: Record<string, unknown> = {
        ...properties,
        timestamp,
        date: now.toISOString().split('T')[0],
        time: now.toTimeString().split(' ')[0],
        $insert_id: insertId,
    };

    if (isPostHogReady(posthog)) {
        posthog.capture(eventName, eventProperties);
        return insertId;
    }

    sendAnalyticsBeacon({
        event: eventName,
        distinctId,
        insertId,
        properties: eventProperties,
    });

    return insertId;
};
